import {
  makeStyles,
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';
import cx from 'classnames';
import getScrollBarWidth from 'helpers/getScrollBarWidth';
import Skeleton from '@material-ui/lab/Skeleton';
import { FAKE_TITLE_DATA } from '../Shared/FakeDataGenerator';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(1.25, 3, 0, 3),
    width: '100%',
    height: '100%',
    borderRadius: 0,
    overflow: 'hidden',
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
  },
  titleBox: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.colors.lightBlue,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
  },
  titleItem: {
    position: 'relative',
    marginLeft: 4,
    fontWeight: 500,
    fontSize: 36,
  },
  titleTextBox: {
    maxHeight: 35,
    // maxWidth: 700,
    width: '100%',
    minWidth: 250,
    display: 'flex',
    alignItems: 'center',
  },
  underTitleBox: {
    fontSize: 15,
    letterSpacing: 0,
    display: 'flex',
    color: theme.colors.blue2,
    marginLeft: 4,
  },
  actions: (props) => ({
    height: 49,
    paddingRight: theme.spacing(props.scrollBarWidth),
    display: 'flex',

    [theme.breakpoints.between(0, 1315)]: {
      paddingTop: theme.spacing(props.hasTopPaddingForSmallScreen ? 2 : 0),
    },
  }),
  container: {
    paddingBottom: theme.spacing(3),
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    '--webkit-overflow-scrolling': 'touch', // possible solution for Safari chopping scrolling issue
    '--webkit-transform': 'translate3d(0, 0, 0)', // founded here https://stackoverflow.com/questions/24156709/choppy-scrolling-in-safari
  },
}));

const ContentWrapper = ({
                          title,
                          titleText,
                          additionTitleButton,
                          actions,
                          children,
                          className,
                          additionalNode,
                          underTitleText,
                          scrollBarSupport,
                          titleClassName,
                          underTitleTextStyle,
                          actionsStyle,
                          hasTopPaddingForSmallScreen,
                          containerStyle = {},
                          titleContainerStyle = {},
                          titleStyle = {},
                          maxWidth,
                          ...rest
                        }) => {
  const scrollBarWidth = scrollBarSupport ? getScrollBarWidth() + 1.5 : 0;
  const classes = useStyles({ scrollBarWidth, hasTopPaddingForSmallScreen });

  return (
    <Paper className={cx(classes.paper, className)} {...rest}>
      <Grid
        container
        justify='space-between'
        alignItems='center'
        direction={{ xs: 'column', lg: 'row' }}
        style={titleContainerStyle}
      >
        <Grid item style={{ flexWrap: 'nowrap', ...titleStyle }}>
          <Grid container justify='flex-start' alignItems='center' style={{ flexWrap: 'nowrap' }}>
            {title && (<div className={cx(classes.titleBox, titleClassName)}>{title}</div>)}
            {titleText === FAKE_TITLE_DATA && (
              <Grid item className={classes.titleTextBox} style={{
                maxWidth: maxWidth || 700
              }}>
                <div style={{ width: '100%' }}><Skeleton variant='text' height={56} /></div>
              </Grid>
            )}
            {titleText && titleText !== FAKE_TITLE_DATA && (
              <Grid item className={classes.titleTextBox} style={{
                maxWidth: maxWidth || 700
              }}>
                <Typography noWrap className={classes.titleItem}>{titleText}</Typography>
              </Grid>
            )}
            {additionTitleButton}
          </Grid>
          {underTitleText && (
            <Typography className={cx(classes.underTitleBox, underTitleTextStyle)}>
              {underTitleText}
            </Typography>
          )}
        </Grid>
        {!!actions && (
          <Grid item className={cx(classes.actions, actionsStyle)}>
            {actions}
          </Grid>
        )}
      </Grid>
      {!!additionalNode && additionalNode}
      <div
        className={cx(classes.container)}
        style={containerStyle}
        id={'contentArea'}
      >
        {children}
      </div>
    </Paper>
  );
};

export default ContentWrapper;
